import { hasAdminRole, hasPermission, type Permission } from "./permissions";
import { useAuth } from "./use-auth";

/** Hook form of hasPermission for the current user. */
export function useCan(p: Permission): boolean {
  const { user } = useAuth();
  return hasPermission(user, p);
}

/** Hook form of hasAdminRole for the current user. */
export function useIsAdmin(): boolean {
  const { user } = useAuth();
  return hasAdminRole(user);
}
